const StudyVisa = () => {
    return (
    

    <div>
        <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">    

                <div className="px-1 flex flex-col justify-center lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem]">
                    <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                        Study / Conference / Medical Visa Applications
                    </h1>
                    <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                        Visatronix makes it convenient to apply for all eligible visas for participating countries. 
                        In addition to business, transit, tourist visa applications, Visatronix offers an easy way 
                        to complete the whole visa application process under one roof. Customers are not only 
                        provided with the complete guidance about the requirements of each type of visa e.g. study, 
                        conference, or medical etc. but also assisted throughout the application process.
                    </p>
                    
                </div>
                <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
                    <img src="/visatronix/studyconference.jpg" alt="" className="rounded-md w-[100%]"/>
                    
                </div>
            </div>

        </div>

    </div>


    )
}
export default StudyVisa;